/**
 * @description Specifies the different model variable types and provides some helper functions
 */
export const VariableType = {
  0: 'String',
  1: 'Bool',
  2: 'Int',
  3: 'Float',
  4: 'DateTime',
  5: 'Unit',
  6: 'CustomType',
  'String': 0,
  'Bool': 1,
  'Int': 2,
  'Float': 3,
  'DateTime': 4,
  'Unit': 5,
  'CustomType': 6,
  
  /**
   * @description Checks if the given variable type is a numeric type
   * @param {number|string} type An variable type to check
   * @returns {boolean} True, if the given variable type is a numeric type
   */
  isNumber( type ) {
    return type === VariableType.Float || type === VariableType.Int || 
           VariableType[type] === VariableType.Int || VariableType[type] === VariableType.Float;
  }
};